import { render } from "./DeviceCard.vue?vue&type=template&id=56ed5f20&scoped=true"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"

import "./DeviceCard.vue?vue&type=style&index=0&id=56ed5f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ed5f20"]])

export default __exports__